<template>
    <v-card flat :loading="isLoading" width="100%">
        <v-card-subtitle v-if="additionalExpenses.length <= 0"
            >No additional expense available</v-card-subtitle
        >
        <v-card-text>
            <v-row v-if="additionalExpenses.length > 0">
                <v-col
                    cols="12"
                    sm="12"
                    v-for="i in additionalExpenses"
                    :key="i.order_id"
                >
                    <v-card>
                        <v-card-title class="d-flex justify-space-between">
                            <div>{{ i.addl_amount | currency }}</div>
                        </v-card-title>
                        <v-card-text>
                            Order ID : {{ i.order_id }}
                            <div v-if="i.ot === 'App\\Models\\Restaurantorder'">
                                Partner : {{ i.restaurant_name }}
                            </div>
                            <div v-else>Job: {{ i.customer_name }}</div>
                            <div>
                                <v-chip small label>{{
                                    i.payment_type
                                }}</v-chip>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script>
import additionalExpApi from '@/api/additionalExpenseApi';

export default {
    props: {
        date: {
            type: String,
            default: null
        },
        courierInfoId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            additionalExpenses: [],
            isLoading: false
        };
    },
    mounted() {
        this.fetchAdditionalExpense();
    },
    watch: {
        date: function(a, b) {
            if (a !== b) {
                this.fetchAdditionalExpense();
            }
        }
    },

    methods: {
        async fetchAdditionalExpense() {
            try {
                this.isLoading = true;
                this.total = 0.0;
                var params = new URLSearchParams();
                // if (this.orderId) {
                //     params.append('order_id', this.orderId);
                // }
                if (this.date) {
                    params.append('date', this.date);
                }
                // if (this.restaurantId) {
                //     params.append('restaurant_id', this.restaurantId);
                // }
                if (this.courierInfoId) {
                    params.append('courier_info_id', this.courierInfoId);
                }
                var k = await additionalExpApi.getTotalAdditionalExpenses(
                    params.toString()
                );
                if (k.data) {
                    this.additionalExpenses = k.data;
                }
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>
